import environmentConfig from "./environments";

const { rabbitMQ } = environmentConfig;

export class WebSocketConfig {
  static WS_URL = rabbitMQ.url;

  static WS_TOPIC = (topic) => `/amq/queue/${topic}`;

  static WS_LOGIN = rabbitMQ.login;

  static WS_PASS_CODE = rabbitMQ.passCode;

  static WS_HOST = rabbitMQ.host;
}
